var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88889 1.73889H1.73889V1.88889V15.1111V15.2611H1.88889H15.1111H15.2611V15.1111V1.88889V1.73889H15.1111H1.88889ZM0.15 1.88889C0.15 0.923398 0.923398 0.15 1.88889 0.15H15.1111C16.0766 0.15 16.85 0.923398 16.85 1.88889V15.1111C16.85 16.0766 16.0766 16.85 15.1111 16.85H1.88889C0.923398 16.85 0.15 16.0766 0.15 15.1111V1.88889ZM13.0722 5.51667H3.92778V3.92778H13.0722V5.51667ZM13.0722 9.29445H3.92778V7.70556H13.0722V9.29445ZM10.2389 13.0722H3.92778V11.4833H10.2389V13.0722Z",
    fill: "#5B88BA",
    stroke: "white",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.75b0fbb493c5aed9c3aa50b93461e11c.svg";
export { ForwardRef as ReactComponent };